<template>
    <div class="overflow-div"><div class="inner">
        <!-- ショールーム利用規約<br><br> -->

        本規約は、株式会社Freeliving.（以下「当社」といいます。）が提供するAUMA（以下「本サービス」といいます。）の利用に関し、当社と利用希望者及びショールーム（第1条で定義します。）の間に適用されます。<br><br>

        <h3 class="heading">第１章 総則</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１条（定義）</h4>
            <p class="indent1">（１）「AUMA」とは、本条第4号で定義するショールーム利用者が、第6号で定義するブランド利用者と第8号で定義するショップ利用者とのマッチングの場を提供することを内容とする当社のウェブサービスのことをいいます。<br>
            （２）「ショールーム」とは、ブランド利用者とショップ利用者の仲介・営業活動を行うために、本サービス内に設けられた情報掲載サイトのことをいいます。<br>
            （３）「利用希望者」とは、本サービスの内、ショールームの利用を希望する事業者をいいます。<br>
            （４）「ショールーム利用者」とは、ショールームを運営する事業者のことをいいます。<br>
            （５）「ブランド」とは、事業者が生産する製品に対し、当該事業者が定める目的・コンセプト・対象顧客等を基準に区分した、当該事業者が設定する特定の製品群のことをいいます。<br>
            （６）「ブランド利用者」とは、生産者・作家・デザイナー等を有し、ブランドを手がける事業者をいいます。<br>
            （７）「ショップ」とは、事業者が運営しているショップ・サロン・ECサイト・商業施設等をいいます。<br>
            （８）「ショップ利用者」とは、ショップ・サロン・ECサイト・商業施設等にて小売事業を運営している事業者をいいます。<br>
            （９）「本契約」とは、当社とショールーム利用者との間における本サービスの契約のことをいいます。<br>
            （１０）「本サイト」とは、本サービスを提供するWebサイトをいいます。<br>
            （１１）「ショールーム情報」とは、ショールーム利用者がブランド利用者又はショップ利用者に向けて公開するショールームに関する第2条第1項各号に定める情報その他本サービス上で公開する情報をいいます。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２条（本サービスの概要）</h4>
            <p>１　本サービスの概要（本サービスを使用することでできること）は、次の各号に定める通りとします。</p>
            <p class="indent1">（１）本サービス上でショップ及びブランドが公開している情報の確認<br>
            （２）本サービス内のツール『My select room』でお気に入りのブランドを登録、及び登録したブランドリストの確認<br>
            （３）ブランド制作スタッフ紹介『hitotonari』の閲覧<br>
            （４）本サイト上におけるブランドの展示会やお知らせメールの受信<br>
            （５）本サービス内のチャットルーム『AUMAトーク』でブランド利用者とのチャット<br>
            （６）ショールーム紹介ページの作成<br>
            （７）ショールーム又はブランドの詳細写真の登録（6枚まで）<br>
            （８）ショールームコンセプトの作成<br>
            （９）その他取扱ブランドの表示・展示会・ポップアップ情報・ショールーム又はブランドの詳細動画（コンセプトムービーやコレクションムービー）の公開<br>
            （１０）ブランド紹介ページのDetailの掲載（価格軸/カテゴリ/プライス/ターゲット/オンライン/WEBのURL/対象店舗可 又は 卸無し の表示・拠点又は生産地）<br>
            （１１）ブランド制作スタッフ紹介『hitotonari』の登録<br>
            （１２）ハッシュタグの登録<br>
            （１３）気になるショップ利用者へ展示会情報やお知らせメールの自動送信（ショップ利用者の内、ショールームを『My select room』に入れていただいた方にのみお知らせメールの発信が可能です。）  <br>
            （１４）本サービス内のチャットルーム『AUMAトーク』でショップ利用者とのチャット<br>
            （１５）本サービス内のツール『My select room』でショップからのアプローチの確認<br>
            （１６）他社SNSサービスのリンク掲載</p>
            <p class="indent3">２　本サービスの詳細は、別途、本サイトにて定めるものとします。なお、本サービスの詳細の変更は、ショールーム利用者の認識の有無にかかわらず、本サイト上に掲示するか、又はショールーム利用者へ電子メールで通知することにより行われるものとします。<br>
            ３　ショールーム利用者は、第1項各号の定めにかかわらず、本サービスがショールーム利用者間のマッチングに利用することができないことを理解し承諾するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->


        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第３条（適用）</h4>
            <p class="indent1">１　本規約は、利用希望者及びショールーム利用者と当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。<br>
            ２　当社は、本サービスに関し、本規約のほか、本サイト等でご利用にあたってのルール、その他各種の定め（以下「個別規定」といいます。）を設けることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。<br>
            ３　本規約の規定が前項の個別規定の内容と矛盾する場合には、個別規定において特段の定めなき限り、個別規定の内容が優先されるものとします。<br>
            ４　利用希望者及びショールーム利用者が、ブランド利用者又はショップ利用者としての登録があり、ブランド利用者又はショップ利用者として本サービスを利用する場合は、本規約とは別に各種規約（ブランド利用者及びショップ利用者に適用のある規約のことを指します）のそれぞれについても遵守するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第４条（本規約の変更）</h4>
            <p class="indent1">１　本規約は、民法第548条の2第1項に定める定型約款に該当し、本規約の各条項は、利用希望者及びショールーム利用者の一般の利益に適合する場合又は変更を必要とする相当の事由があると認められる場合には、同条の規定に基づいて変更できるものとします。<br>
            ２　前項による本規約の変更は、変更後の規約の効力発生日の1ヶ月前までに、本規約を変更する旨及び変更後の本規約の内容を、本サイトで公表するものとします。<br>
            ３　本規約の変更の効力発生日以後、本サービスの利用を開始した場合には、利用希望者及びショールーム利用者は変更後の規約に同意したものとみなします。</p>
        </div>
        <!-- terms-item-wrap END -->


        <h3 class="heading">第２章　申込み・登録</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第５条（利用登録）</h4>
            <p>１　本サービスを利用するためには、当社の登録を受け本サービスのショールーム利用者となる必要があります。利用希望者は、本規約に同意の上、利用登録を申請するものとします。<br>
            ２　利用登録の申請に際して、当社は申請のあったショールームごとに審査を行います。当社が依頼した場合、利用希望者は速やかに、当社が依頼する情報を当社に提出するものとし、その他当社による審査に協力するものとします。<br>
            ３　当社が利用登録の申請を承認することによって、利用登録が完了します。利用登録が完了した場合、当社からID及びパスワードを発行し、利用希望者と当社との間に本契約が成立するものとします。また、本契約成立により利用希望者は、ショールーム利用者となります。本契約成立により、ショールーム利用者には、第17条に定める利用料金が発生します。<br>
            ４　当社は、利用希望者に次の各号のいずれかに該当する事由があると判断した場合、利用登録の申請を承認しないことがあります。この場合、当社は、承認しなかったことについて一切の責任を負わず、承認しなかった理由を開示する義務を負わないものとします。</p>
            <p class="indent1">（１）衣装等の製造業者と小売店との仲介事業を現に行っていないと認められる場合<br>
            （２）ショールームが第三者のショールームと誤認混同を与える場合又は与えるおそれがある場合<br>
            （３）登録事項の全部又は一部につき、虚偽、誤記又は記載漏れがあった場合<br>
            （４）本規約に違反する行為を行うおそれがある場合又は過去に違反した事実があった場合<br>
            （５）商人及び事業者ではない場合<br>
            （６）商行為を目的としていないと当社が判断する場合<br>
            （７）反社会的勢力の構成員又はその関係者である場合<br>
            （８）その他当社が不適当と判断した場合</p>
            </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第６条（他のプランへの登録変更）</h4>
            <p>ショールーム利用者が選択しているプランについて、他のプランに変更する場合、当社は登録のための審査を再度行います。この場合、当社は前条第4項を準用します。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第7条（登録情報）</h4>
            <p>１　ショールーム利用者は、登録情報に変更が生じた場合、速やかにその変更の内容を当社に届け出るものとします。登録内容の変更が、適切に行われなかったことにより生じた損害等については、当社は一切の責任を負いません。<br>
            ２　ショールーム利用者は、次の各号のいずれかの事由に該当することとなった場合は、速やかに当社にその旨を報告するものとします。</p>
            <p class="indent4">（１）支払停止若しくは支払不能となり、又は破産手続、民事再生手続、会社更生手続、特別清算手続その他これらに類する手続の開始の申立てがあった場合<br>
            （２）自ら振り出し、若しくは引き受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき<br>
            （３）差押え、仮差押え、仮処分、強制執行又は競売の申立てがあった場合<br>]
            （４）租税公課の滞納処分を受けた場合</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第８条（ID 及びパスワードの管理）</h4>
            <p>１　ショールーム利用者は、自己の責任において、本サービスのID及びパスワードを適切に管理するものとします。<br>
            ２　ショールーム利用者は、いかなる場合にも、ID及びパスワードを第三者に譲渡又は貸与し、若しくは第三者と共用することはできません。当社は、IDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのIDを登録しているショールーム自身による利用とみなします。<br>
            ３　ID及びパスワードが第三者によって使用されたことによって生じた損害について、当社は一切の責任を負わないものとします。</p>
        </div>
        <!-- terms-item-wrap END -->


        <h3 class="heading">第３章　本サービスの利用</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第９条（本サービスの利用条件等）</h4>
            <p>１　ショールーム利用者は、本サービスを利用するにあたって本規約（個別規定を含みます）に従わなければならないものとします。<br>
            ２　ショールーム利用者は、第5条による利用登録完了後、本サービスのブランド用BASICプランで登録されている2以上のブランド利用者から、ショールームにおける取扱いの申請を受け、ショールーム利用者がこれを承認するまでは、本サービスの利用を開始することができません。<br>
            ３　前項の申請を行ってくれるブランド利用者の探索はショールーム利用者自身で行うものとし、当社は申請を行ってくれるブランド利用者の探索・紹介等は一切行いません。<br>
            ４　当社は、ショールーム利用者が申請を行ってくれるブランド利用者を見つけることができず、本サービスを利用できないことによって損害が生じたとしても、一切責任を負わず、ショールーム利用者から受領した金員も一切返還しません。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１０条（ショールーム情報の掲載）</h4>
            <p>１　ショールーム利用者は、当社が定める事項においてショールーム情報を掲載できるものとします。<br>
            ２　ショールーム利用者は、ショールーム情報の掲載にあたり、ショールーム情報にかかる情報内容が正確かつ真実であること、並びに、ショールーム情報にかかるサービスを提供するために必要な資格、許認可、権限及び能力を有することを表明し、保証するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１１条（ブランド利用者又はショップ利用者とのマッチング）</h4>
            <p>協議が成立し、ショールーム利用者とブランド利用者又はショップ利用者との間で契約が成立した場合、ショールーム利用者は、当該相手方との間における契約に定める自らの義務を誠実に履行するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１２条（禁止事項）</h4>
            <p>１　ショールーム利用者は、自ら又は第三者を通じて、本サービスと同一又は類似するサービスを第三者に提供する行為をしてはならないものとします。<br>
            ２　ショールーム利用者は、前項に定めるもののほか、 次の各号のいずれかに該当する行為又は該当すると当社が判断する行為をしてはならないものとします。</p>
            <p class="indent4">（１）本サービスの改変、リバースエンジニアリング（ソフトウェア又はプログラムの内容を解析して、人間が読み取り可能な形に変換することを指します。）、逆コンパイル、逆アセンブルその他これらに  類する行為。<br>
            （２）本サービス利用目的を超えて本サービスを使用する行為、又は当社が許諾した利用態様を超えて、本サービスを複製、公衆送信、頒布、譲渡、貸与する行為。<br>
            （３）本サービスを第三者に利用させる行為又は第三者が利用できる状態にする行為。<br>
            （４）本サービスを通じ、次の事項に該当し、又は該当すると当社が判断する情報を送信、アップロード等する行為。</p>
            <p class="indent5">a. コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報。<br>
            b. 当社、ブランド利用者、ショップ利用者、他のショールーム利用者、その他の第三者の名誉又は信用を毀損する表現を含む情報。<br>
            c. 反社会的な表現や他人に不快感を与える表現を含む情報。<br>
            d. チェーンメール等の第三者への情報の拡散を求める情報。</p>
            <p class="indent4">（５）本サービスのネットワーク又はシステム等に過度な負担をかける行為。<br>
            （６）当社のネットワーク又はシステム等に不正にアクセスし、又は不正なアクセスを試みる行為。<br>
            （７）他のショールーム利用者、他の本サービス利用者のID又はパスワードを利用する行為その他第三者になりすます行為。<br>
            （８）当社、他のショールーム利用者、その他の第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利又は利益を侵害する行為。<br>
            （９）他のショールーム利用者、その他の第三者の個人情報、登録情報、利用履歴情報等を収集、開示又は提供する行為。<br>
            （１０）登録しているショールーム以外の仲介・営業活動のために本サービスを利用する行為。<br>
            （１１）宗教活動又は宗教団体への勧誘行為。<br>
            （１２）反社会的勢力への利益供与その他の関与。<br>
            （１３）本サービスの運営を妨害するおそれのある行為。<br>
            （１４）当社、ブランド利用者、ショップ利用者、他のショールーム利用者、その他の第三者に対する詐欺又は強迫行為。<br>
            （１５）当社、ブランド利用者、ショップ利用者、他のショールーム利用者、その他の第三者に不利益・損害・不快感を与える行為。<br>
            （１６）法令、裁判所の確定した判決、決定若しくは命令、又は法令上拘束力のある行政措置に違反する行為。<br>
            （１７）公序良俗に反する行為。<br>
            （１８）商行為を目的としない本サービス利用行為。<br>
            （１９）本規約、個別規定に抵触する行為。<br>
            （２０）前各号の行為を直接又は間接に惹起し、又は容易にする行為。<br>
            （２１）その他、当社が不適切と判断する行為。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１３条（本サービスの適正利用）</h4>
            <p>１　ショールーム利用者は、本サービスの利用に際して、ショールーム利用者に適用のある法律、政令、条例等（以下「法令等」といいます。）を自らの責任及び費用により遵守するものとします。当社は、ショールーム利用者による本サービスの利用が、ショールーム利用者に適用のある法令等に適合することを何ら保証しません。<br>
            ２　ショールーム利用者は、本サービスに関しショールーム利用者の利用に供された機器（当社サーバ等当社が準備した機器を含み、以下「本件機器」といいます。）に保存されたデータ（個人情報、秘密情報その他当該本サービスの提供開始以降に本件機器のショールーム用の領域上に保存されたすべてのデータをいい、以下「ショールームデータ」といいます。）を、自己の責任及び費用において管理し、バックアップを行うものとします。当社は、ショールームデータに対して何ら関与及び関知するものではなく、事由の如何にかかわらず、次の各号に該当する事項について、何ら責任を負うものではありません。</p>
            <p class="indent4">（１）ショールームデータの滅失の発生<br>
            （２）ショールームデータの滅失に対する当社での予防<br>
            （３）ショールームデータの滅失が発生した場合の当社での対応及びショールームデータの復旧</p>
            <p>３　本契約が終了した場合、当社は、本件機器に保存されていたショールームデータを自らの裁量で削除することができ、当該削除に関し何らの責任も負わないものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１４条（当社からの通知又は連絡）</h4>
            <p>１　当社からのショールーム利用者に対する通知又は連絡は、登録されている連絡先への電子メールによる方法、本サイトを通じての方法その他当社の定める方法によって行うものとします。<br>
            ２　当社は、ショールーム利用者から、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知又は連絡を行い、これらは発信時にショールーム利用者へ到達したものとみなします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１５条（サービス利用環境）</h4>
            <p>１　ショールーム利用者は、本サービスを利用するための利用端末、電子機器、通信機器、ソフトウェア、インターネット接続環境等を自己の責任と負担で準備するものとします。<br>
            ２　本サービスを利用するにあたり発生する通信費等は、ショールーム利用者が負担するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
        <h4>第１６条（確認事項）</h4>
            <p>１　ショールーム利用者とブランド利用者又はショップ利用者との間でなされる一切の契約関係は、ショールーム利用者とブランド利用者又はショップ利用者との間に生じるものであって、当社が当事者と なるものではありません。ショールーム利用者とブランド利用者又はショップ利用者との間に紛争が生じた場合、ショールーム利用者は自らの責任及び費用によりこれを解決するものとし、当社は一切の責任を負いません。<br>
            ２　ショールーム利用者と当社は、ショールーム利用者とブランド利用者又はショップ利用者の間で契約等が締結されるか否かはショールーム利用者と当該ブランド利用者又はショップ利用者との間における自由な判断に基づくものであることを確認し、当該契約の締結に至らなかった場合でも当社はショールームに対して何らの責任も負いません。<br>
            ３　当社は、ブランド利用者又はショップ利用者の資力について保証するものではありません。ショールーム利用者は、自らの責任及び費用においてブランド利用者又はショップ利用者の資力を確認するものとし、ショールーム利用者がブランド利用者又はショップ利用者との間で契約等を締結したときは、自らの責任及び費用においてブランド利用者又はショップ利用者から対価を回収するものとします。<br>
            ４　ショールーム利用者は、ショールーム利用者が本サービス上で公開・掲載する内容（ショールーム情報を含みますがこれに限られません。）が第三者の著作権その他の権利を侵害しないものであることを保証します。</p>
        </div>
        <!-- terms-item-wrap END -->


        <h3 class="heading">第４章　利用料金及び支払方法</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１７条（利用料金）</h4>
            <p>１　ショールーム利用者は、当社が別途定め、本サイト上に表示する利用料金を、当社が指定する方法により支払うものとします。
            ２　第5条による利用登録が完了すると、前項に定める利用料金が発生します。なお、第9条第2項によるブランド利用者による申請が無く本サービスの利用を開始できない場合でも利用料金は発生します。<br>
            ３　ショールーム利用者が利用料金の支払いを遅滞した場合には、ショールーム利用者は、当社に対して年14．6％の割合による遅延損害金を支払うものとします。</p>

        </div>
        <!-- terms-item-wrap END -->

        <h3 class="heading">第５章　免責及び非保証</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第１８条（免責及び非保証）</h4>
            <p>１　当社は、本サービスの提供に関してショールーム利用者に生じたあらゆる損害について、当社に故意又は重過失があった場合を除き、一切の責任を負いません。当社の故意又は重過失による損害賠償額 については、ショールーム利用者が当社に支払った直近1か月分の利用料金を限度として損害賠償責任を負うものとします。<br>
            ２　当社は、本サービスに不具合、エラーや障害が生じないこと、本サービスの提供する情報（ブランド利用者、ショップ利用者及び他のショールーム利用者が公開する情報を含みますがこれらに限られません。）が正確・適法・真実であること、本サービスの提供がショールーム利用者の特定の目的に適合するものであること、その他本サービスに関する一切の事項について、何らの保証も行いません。<br>
            ３　当社は、ショールーム利用者が本サービスを利用することによる売上、収益、事業の成功について何らの保証も行いません。</p>
        </div>
        <!-- terms-item-wrap END -->

        <h3 class="heading">第６章　契約の終了等</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
        <h4>第１９条（利用停止等）</h4>
            <p>１　当社は、ショールーム利用者が第12条に定める禁止事項を行い、その他本規約のいずれかの規定に違反した場合、ショールーム利用者に事前に通知することなく、いつでも、本サービスの提供の全部若しくは一部の停止、その他当社が適切と判断する措置を行うことができます。また、この場合、ショールーム利用者は、ショールーム利用者が当社に対して負担する債務の全てについて、当然に期限の利益を失うものとします。<br>
            ２　前項に基づき、当社がショールーム利用者に対して何らかの措置を講じた場合であっても、当社は、これによりショールーム利用者に発生した損害について一切の責任を負わないものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２０条（解除）</h4>
            <p>１　ショールーム利用者が次の各号のいずれかに違反したときは、当社は、催告なく、ショールーム利用者との間で締結している本契約を解除し、その提供を停止することができるものとします。なお、ショールーム利用者が複数の登録を受けたショールーム（複数のID・パスワード）で本サービスを利用している場合、一つのショールームに関する契約が解除されたときは、その他のショールームに関する契約についても解除されるものとします。</p>
            <p class="indent4">（１）本規約に違反する行為を行った場合<br>
            （２）当社に提供された情報の全部若しくは一部につき虚偽、誤記又は記載漏れがあった場合<br>
            （３）支払期限が過ぎても利用料金の支払いが確認できない場合<br>
            （４）仮差押、差押、競売、破産手続開始、会社更生手続開始、民事再生手続開始等の申立があった場合、又は公租公課等の滞納処分を受けた場合<br>
            （５）過去に本サービスについて当社から解除されていることが判明した場合<br>
            （６）第27条の確約に反する場合<br>
            （７）その他、当社がショールーム利用者として不適当であると合理的に判断した場合</p>
            <P>２　ショールーム利用者が前項各号のいずれかに該当した場合、ショールーム利用者が当社に対して負っている債務がある場合には、ショールーム利用者は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務を支払わなければなりません。<br>
            ３　第1項に基づきショールーム利用者が本契約を解除された場合でも、当社は、既に受領した利用料金の返金は行わず、また、ショールーム利用者及び第三者に生じた損害並びに不利益につき一切の責任を負いません。</P>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２１条（本サービスの中断及び終了）</h4>
            <p>１　当社は、次の各号のいずれかに該当する場合、ショールーム利用者に通知することなく、本サービスの全部又は一部の提供を一時的に中断できるものとします。</p>
            <p class="indent4">（１）本サービスに関する緊急点検を行う場合<br>
            （２）本サービスに関して、電子機器等の不具合、通信障害、不正アクセス、コンピュータウイルスその他のシステムトラブルが発生した場合<br>
            （３）自然災害、テロ、暴動等の不可抗力による場合<br>
            （４）その他、やむを得ない事情がある場合</p>
            <p>２　当社は本サービスの継続的な提供が困難だと判断した場合、又は当社の運営上本サービスの廃止が必要であると判断した場合、その他やむを得ない事由が発生した場合、ショールーム利用者に通知の上、本サービスの提供を終了することができるものとします。ただし、やむを得ない事情がある場合、ショールーム利用者への事前の通知を行うことなく、本サービスの提供を終了することがあります。<br>
            ３　当社が本サービスの提供を中断又は終了した場合、当社はショールーム利用者に対し、ショールーム利用者が支払った利用料金のうち、本サービスを中断した期間又は終了した日以後の契約残存期間に相当する金額を日割り計算にて返金するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２２条（中途解約）</h4>
            <p>１　ショールーム利用者は、当社が別途定める手続により、本契約を中途解約できるものとします。<br>
            ２　中途解約するにあたり、当社に対して負っている債務がある場合には、ショールーム利用者は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務を支払わなければなりません。<br>
            ３　当社は、月の途中でショールーム利用者が中途解約をされた場合であっても、日割計算による精算は行いません。</p>
        </div>
        <!-- terms-item-wrap END -->



        <h3 class="heading">第７章　雑則</h3>

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２３条（知的財産権）</h4>
            <p>１　ショールーム利用者は、自ら著作権等の必要な知的財産権を有する、又は必要な権利者の許諾を得た文章、画像や映像等の情報に関してのみ、本サービスを利用して投稿ないしアップロードすることできるものとします。<br>
            ２　ショールーム利用者が本サービスを利用して投稿ないしアップロードした文章、画像、映像等の著作権については、当該ショールーム利用者その他権利者に留保されるものとします。ただし、当社は、サービスを利用して投稿ないしアップロードされた文章、画像、映像等について、本サービスの改良、品質の向上、又は不備の是正等ならびに本サービスの周知宣伝等に必要な範囲で利用できるものとし、ショールーム利用者は、この利用に関して、著作者人格権を行使しない、及び権利者に著作者人格権を行使させないものとします。<br>
            ３　前項本文に定めるものを除き、本サービス及び本サービスに関連する一切の情報についての著作権およびその他の知的財産権はすべて当社又は当社にその利用を許諾した権利者に帰属し、ショールーム利用者は無断で複製、譲渡、貸与、翻訳、改変、転載、公衆送信（送信可能化を含みます。）、伝送、配布、出版、営業使用等をしてはならないものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２４条（不可抗力）</h4>
            <p>１　当社は、通常講ずるべき対策では防止できないコンピュータウイルスによる被害、停電被害、サーバ故障、回線障害又は天変地異による被害、感染症の罹患・拡大、その他当社の責によらない不可抗力に基づく事由（以下「不可抗力」といいます。）による被害が利用希望者又はショールーム利用者に生じた場合、一切責任を負わないものとします。<br>
            ２　当社は、不可抗力に起因して本サービスに関して管理又は提供されるデータが消去又は変更されないことを保証しません。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
        <h4>第２５条（問い合わせ方法）</h4>
            <p>利用希望者及びショールーム利用者の当社への問い合わせは、電子メール、本サイトを通じた方法、その他当社が定める方法によるものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２６条（権利義務及び本規約上の地位の譲渡禁止）</h4>
            <p>利用希望者及びショールーム利用者は、当社からの事前の書面による同意なしに、本規約上の権利義務の全部又は一部及び本規約上の地位を譲渡することはできません。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
        <h4>第２７条（反社会的勢力の排除）</h4>
        <p>１　当社、利用希望者及びショールーム利用者は、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、 総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下「暴力団員等」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。</p>
        <p class="indent4">（１）暴力団員等が経営を支配していると認められる関係を有すること。<br>
            （２）暴力団員等が経営に実質的に関与していると認められる関係を有すること。<br>
            （３）自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること。<br>
            （４）暴力団員等に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること。<br>
            （５）役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること。
            ２　当社、利用希望者及びショールーム利用者は、自ら又は第三者を利用して次の各号に該当する行為を行わないことを確約します。<br>
            （１）暴力的な要求行為。<br>
            （２）法的な責任を超えた不当な要求行為。<br>
            （３）風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為。<br>
            （４）法令、公序良俗に反する行為、又はそのおそれがある行為。<br>
            （５）その他前各号に準ずる行為。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２８条（秘密保持）</h4>
            <p>１　利用希望者及びショールーム利用者は、本サービスの利用に関連して知り得た当社の業務上の情報、技術情報、ノウハウ等の一切の情報（以下「秘密情報」といいます。）について、本サービスの利用目的以外で利用せず、また如何なる第三者にも開示、漏洩しないものとします。ただし、法令の定めに基づき官公庁から開示を強制されたものについては、当該官公庁に限り開示することができます。また、次の各号のいずれかに該当する場合には、秘密情報から除くものとします。</p>
            <p class="indent4">（１）知得したときに既に公知であった情報。<br>
            （２）知得したときに既に利用希望者又はショールーム利用者が適法に所有していた情報。<br>
            （３）知得した後に利用希望者又はショールーム利用者の責に帰し得ない事由により公知となった情報。<br>
            （４）知得した後に第三者から秘密保持義務を負うことなく適法に取得した情報。<br>
            （５）知得の前後を問わず利用希望者又はショールーム利用者が独自に開発した情報。</p>
            <p class="indent3">２　当社から提供された秘密情報及び秘密情報が記載された資料については、利用希望者及びショールーム利用者は厳重に管理の上、提供を受けた利用希望者及びショールーム利用者 のみで取扱い、複製又は第三者に貸与、譲渡してはなりません。<br>
            ３　本条の規定は、本契約期間中及び本契約終了後3年間有効とします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第２９条（個人情報）</h4>
            <p>個人情報の取扱いについては、当社が別途定めるプライバシーポリシーに従うものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第３０条（広告宣伝）</h4>
            <p>当社は、ショールーム利用者の同意を得た上で、本サービスの広告宣伝のために、ショールーム及びショールーム利用者の名称・標章等を使用する場合があります。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第３１条（分離条項）</h4>
            <p>本規約に定めるいずれかの条項が管轄権のある裁判所により無効である旨判断された場合には、かかる条項は、法律が許容する限りで、本来の条項の趣旨を最大限実現するように変更又は解釈されるものとし、また、本規約のその他の条項の効力には何らの影響を与えないものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第３２条（契約言語）</h4>
            <p>本規約は、日本語で作成されるものとし、日本語以外の言語で作成された場合であっても参考のために作成するものにすぎず、内容に疑義が生じた場合は、日本語により規定される内容が優先するものとします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <h4>第３３条（準拠法及び管轄）</h4>
            <p>本規約の準拠法は日本法とし、本規約に関する一切の紛争は、大分地方裁判所又は大分簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
        </div>
        <!-- terms-item-wrap END -->

        <!-- terms-item-wrap -->
        <div class="terms-item-wrap">
            <p>最新更新：2022年12月1日</p>
        </div>
        <!-- terms-item-wrap END -->
    </div></div>
</template>

<style>
.overflow-div {
    height: calc( 1.75em * 20 );
    line-height: 1.75;
    border: solid 1px;
    overflow-y: scroll;
    /* white-space: nowrap; */
}
.overflow-div .inner {
	margin: auto;
	padding: 3rem 2rem;
    text-align: justify;
    word-break: break-all;
}
.overflow-div .inner h3.heading {
    font-size:1.25rem;
    font-weight: 700;
	padding-bottom: 1rem;
    text-align: center;
}
.overflow-div div.terms-item-wrap {
    padding-bottom: 1rem;
	margin-bottom: 1rem;
}
.overflow-div div.terms-item-wrap h4 {
    font-size:1.1rem;
    font-weight: 700;
}
.overflow-div div.terms-item-wrap ol {
    padding-left: 3rem;
}
.overflow-div div.terms-item-wrap ol li {
    text-indent: -2em;
    padding-left: 2em;
}
.indent1 {
    text-indent: -1em;
    padding-left: 1em;
}
.indent2 {
    text-indent: -1em;
    padding-left: 3em;
}
.indent3 {
    text-indent: 0em;
    padding-left: 1em;
}
.indent4 {
    padding-left: 2em;
}
.indent5 {
    padding-left: 4em;
}
</style>
